import React, {useState, useEffect, useRef, useContext} from "react";
import {DEFAULT_BLUE} from "../constants/general-constants";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {functions} from "../constants/common-functions";
import {useHistory} from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import {NO_STRINGIFY} from "../constants/general-constants";
import {store} from '../context/store';
import Header from "../components/Header";
import LeftMenu from "../components/LeftMenu";
import GoogleMap from "../components/GoogleMap";
import {useParams} from "react-router-dom";

export default function Site(){
	const globalState = useContext(store);
	
	const siteId = useParams()["siteId"];
	const [loaded, setLoaded] = useState(false);
	const [locations, setLocations] = useState([]);
	const [facilityTypeMaps, setFacilityTypeMaps] = useState([]);
	
	useEffect(() => {
		if(loaded === false){
			functions.getArrayFromAjax("/resolutionsoftwareplatform/facilitytypemaps?siteId=" + siteId, setFacilityTypeMaps, populateLocations);
			setLoaded(true);
		}
	}, []);
	
	
	const populateLocations = () => {
		functions.getObjectFromAjax("/resolutionsoftwareplatform/facilitiesformap?siteId=" + siteId, setLocations, null);
	};
	
	

	 const thisContainer = {
  	display:"flex",
  	position:"fixed",
  	flexDirection:"column",
  	width:"100%",
  	height:"100vh",
  	left:"0px",
  	top:"0px",
  	//backgroundColor:GREY_BACKGROUND
  };
  
  const mainContainer = {
  	display:"flex",
  	position:"fixed",
  	top:"60px",
  	left:"60px",
  	bottom:"0px",
  	right:"0px",
  	flexDirection:"column",
  	overflow:"auto"
  };
	
	return (
		
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>	
				<div style={mainContainer}>
						<GoogleMap
							facilityTypeMaps={facilityTypeMaps}
							locations={locations}
							parentId={siteId}
						/>
				</div>
			</div>
	);
}